import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型
import { VerifyInfo } from '../../service/class/VerifyInfo';

// 借助 createSlice 创建 reducer、action
const VerifyInfoSlice = createSlice({
    name: 'verifyInfo',
    initialState: {
        value: new VerifyInfo(),
    },
    reducers: {
        setVerifyInfo: (state, action: PayloadAction<VerifyInfo>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setVerifyInfo } = VerifyInfoSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const verifyInfoSelector = (state: RootState) => state.verifyInfo.value;

// Reducer，真正执行修改 state 的纯函数
export default VerifyInfoSlice.reducer;
